import { render, staticRenderFns } from "./ActionResourceSelector.vue?vue&type=template&id=16233808"
import script from "./ActionResourceSelector.vue?vue&type=script&lang=js"
export * from "./ActionResourceSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports